var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", { staticClass: "order-summary__head" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.getTranslation(
                  "licence-configurator",
                  "order_summary_table_title"
                )
              ) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "custom-table custom-table__stretch" },
      [
        _c("div", { staticClass: "row custom-table__head d-none d-sm-flex" }, [
          _c("div", { staticClass: "col-4 col-sm" }, [
            _c("div", { staticClass: "custom-table__head--elem" }, [
              _vm._v(_vm._s(_vm.getTranslation("product-list-vue", "program"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-3 col-sm" }, [
            _c(
              "div",
              { staticClass: "custom-table__head--elem text-sm-center" },
              [
                _vm._v(
                  _vm._s(_vm.getTranslation("licence-configurator", "period"))
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1" }, [
            _c(
              "div",
              { staticClass: "custom-table__head--elem text-sm-right" },
              [
                _vm._v(
                  _vm._s(_vm.getTranslation("licence-configurator", "days"))
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 col-80" }, [
            _c("div", { staticClass: "custom-table__head--elem" }, [
              _vm._v(
                _vm._s(_vm.getTranslation("licence-configurator", "licenses"))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 col-80" }, [
            _c(
              "div",
              { staticClass: "custom-table__head--elem text-sm-right" },
              [_vm._v(_vm._s(_vm.getTranslation("front", "price")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 col-80" }, [
            _c(
              "div",
              { staticClass: "custom-table__head--elem text-sm-right" },
              [_vm._v(_vm._s(_vm.getTranslation("front", "total")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._l(_vm.sortedPrograms(), function (program) {
          return program.product == _vm.product.id &&
            program[_vm.licenceType] > 0
            ? [
                _c(
                  "div",
                  { staticClass: "row no-gutters custom-table__body  " },
                  [
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "product-list-vue",
                                  "program"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8 col-sm" }, [
                      _c("div", { staticClass: "custom-table__body--elem" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(program.name) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "period"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8 col-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-table__body--elem text-sm-center",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "new"
                                )
                              ) +
                              " - " +
                              _vm._s(
                                _vm.getFormattedDate(
                                  _vm.addDaysToToday(
                                    program.days !== false ? program.days : 365
                                  )
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "days"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8 col-sm-1 text-sm-right" }, [
                      _c("div", { staticClass: "custom-table__body--elem" }, [
                        _vm._v(
                          _vm._s(program.days !== false ? program.days : 365)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "licenses"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                      [
                        _c("div", { staticClass: "custom-table__body--elem" }, [
                          _vm._v(_vm._s(_vm.quantity(program))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "price")))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__body--elem custom-table__body--price",
                          },
                          [_vm._v(_vm._s(_vm.linePrice(program)))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "total")))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-2 text-sm-right col-80" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__body--elem custom-table__body--price",
                          },
                          [_vm._v(_vm._s(_vm.totalPrice(program)))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 d-sm-none custom-table__separator",
                    }),
                  ]
                ),
              ]
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.sortedProgramsConfig(), function (program) {
          return [
            _c("div", { staticClass: "row no-gutters custom-table__body  " }, [
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(_vm.getTranslation("product-list-vue", "program"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm" }, [
                _c("div", {
                  staticClass: "custom-table__body--elem",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getProgramName(program.program_id, _vm.product.id)
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getTranslation("licence-configurator", "period")
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm" }, [
                _c("div", {
                  staticClass: "custom-table__body--elem text-sm-center",
                  domProps: {
                    innerHTML: _vm._s(
                      program.lease_end +
                        " " +
                        _vm.shopConfigOptions.upgradeIcon +
                        " " +
                        program.lease_end_new
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(_vm.getTranslation("licence-configurator", "days"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-1 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(_vm._s(program.daysDiff)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getTranslation("licence-configurator", "licenses")
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                [
                  _c("div", { staticClass: "custom-table__body--elem" }, [
                    _vm._v(_vm._s(program.quantity)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "price"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                [
                  _c("div", { staticClass: "custom-table__body--elem" }, [
                    _vm._v(_vm._s(_vm.linePriceConfig(program))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "total"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-8 col-sm-2 text-sm-right col-80" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-table__body--elem custom-table__body--price",
                    },
                    [_vm._v(_vm._s(_vm.totalPriceConfig(program)))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-12 d-sm-none custom-table__separator",
              }),
            ]),
          ]
        }),
        _vm._v(" "),
        _vm._l(_vm.sortedProgramsPerpetual(), function (program) {
          return _vm.hasPerpetualUpgrade()
            ? [
                _c(
                  "div",
                  { staticClass: "row no-gutters custom-table__body  " },
                  [
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "product-list-vue",
                                  "program"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8 col-sm" }, [
                      _c("div", { staticClass: "custom-table__body--elem" }, [
                        _vm._v(_vm._s(program.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "period"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8 col-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-table__body--elem text-sm-center",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "perpetual"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "days"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation(
                                  "licence-configurator",
                                  "licenses"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                      [
                        _c("div", { staticClass: "custom-table__body--elem" }, [
                          _vm._v(_vm._s(_vm.quantity(program))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "price")))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-1 text-sm-right col-80" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__body--elem custom-table__body--price",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(
                                  _vm.getProgramPrice(
                                    program.id,
                                    "",
                                    _vm.licenceType,
                                    program.product,
                                    3
                                  ),
                                  true
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 custom-table__title d-sm-none" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-table__title--elem" },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "total")))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8 col-sm-2 text-sm-right col-80" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__body--elem custom-table__body--price",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(
                                  _vm.getProgramPrice(
                                    program.id,
                                    "",
                                    _vm.licenceType,
                                    program.product,
                                    program[_vm.licenceType] * 3
                                  ),
                                  true
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 d-sm-none custom-table__separator",
                    }),
                  ]
                ),
              ]
            : _vm._e()
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters custom-table__body  " }, [
          _c("div", { staticClass: "col-4 col-sm-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "custom-table__title--elem custom-table__title--total",
              },
              [_vm._v(_vm._s(_vm.getTranslation("front", "total")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-8 col-sm-6 text-sm-right" }, [
            _c(
              "div",
              {
                staticClass:
                  "custom-table__body--elem custom-table__title--total custom-table__body--price",
              },
              [_vm._v(_vm._s(_vm.priceFormat(_vm.getTotalPrice())))]
            ),
          ]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c("br"),
    _c("br"),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 col-sm-1 text-sm-right" }, [
      _c("div", { staticClass: "custom-table__body--elem" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }